/*
Sohel  09/19/2022   3075154998   Integrated API,Added System Notes and Suggested Changes.
dilip  10/07/2022   3075154998   matching logic modifications
dilip  10/10/2022   3075154998   fields changed
dilip  10/11/2022   3075154998   Data Manager Matching logic changes
Suresh Peddavoora   10/26/2022   3075154998  Added Class Name for Text Fields and Buttons.
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/28/2022 3075154998  Modified styles for checkbox
Suresh Peddavoora 10/31/2022 3075154998  Added Grid spacings for Text Fields
Raghu Arun Kumar 11/02/2022 3075154998  Responsive Alignment Fixes
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
sai krishna  1/3/2023  3075154998 formula rule changed to data calculations
*/
import React, {useEffect, useContext, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Button, Grid, TextField, FormHelperText, Typography, Checkbox, FormControl,
  FormControlLabel,
  Tooltip} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getDropDownData} from '../../../../../redux/reducers/EnableFramework/Filter';
import {getObject} from './../../../../../util/GetDropdownObject';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {makeStyles} from '@material-ui/core/styles';
import MatchingLogicSystemNotes from './MatchingLogicSystemNotes';
import {
  postMatchingLogicData,
  resetMessage,
  getClientCodeDropDownData,
  getFormulaRuleDropDownData,
} from '../../../../../redux/reducers/DMMatchingLogic';
import PageLoader from './../../../../../components/PageLoader/index';
import {ErrorSnackbar, SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
const AddDMRecordGroupForm = ({setValue}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const [expanded, setExpanded] = useState();
  const {dropDownData} = useSelector(({filter}) => filter);
  const {
    MatchingLogicData,
    isLoading,
    successMsg,
    errorMsg,
    addMatchingLogicStatus,
    clientCodeDropdownData,
    formulaRuleData,
  } = useSelector(({dMMatchingLogic}) => dMMatchingLogic);
  const options = [
    {value: 'Yes', key: 'Y'},
    {value: 'No', key: 'N'},
  ];
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.clientNumber === option || item?.key === option || item.code === option) {
          label = item;
        }
      });
    return label;
  };
  const initialValues = {
    code:
      MatchingLogicData && MatchingLogicData?.matchingLogicCode ?
        MatchingLogicData?.matchingLogicCode :
        '',
    recordType:
      MatchingLogicData && MatchingLogicData?.recordType ?
        getObject(MatchingLogicData?.recordType, RECORD_TYPE, dropDownData) :
        null,
    description:
      MatchingLogicData && MatchingLogicData?.description ? MatchingLogicData?.description : '',
    exactMatch:
      MatchingLogicData && MatchingLogicData?.exactValue ?
        getObjects(MatchingLogicData?.exactValue, options) :
        null,

    clientCode:
      MatchingLogicData && MatchingLogicData?.clientId ?
        getObjects(MatchingLogicData?.clientId, clientCodeDropdownData) :
        null,
    formulaRule:
      MatchingLogicData && MatchingLogicData?.ruleGroupCode ?
        getObjects(MatchingLogicData?.ruleGroupCode, formulaRuleData) :
        null,
    matchField1:
      MatchingLogicData && MatchingLogicData?.primaryMatchField ?
        MatchingLogicData?.primaryMatchField :
        '',
    dBField1:
      MatchingLogicData && MatchingLogicData?.primaryMatchDbField ?
        MatchingLogicData?.primaryMatchDbField :
        '',
    matchField2:
      MatchingLogicData && MatchingLogicData?.secondaryMatchField ?
        MatchingLogicData?.secondaryMatchField :
        '',
    dBField2:
      MatchingLogicData && MatchingLogicData?.secondaryMatchDbField ?
        MatchingLogicData?.secondaryMatchDbField :
        '',
    matchField3:
      MatchingLogicData && MatchingLogicData?.teriaryMatchField ?
        MatchingLogicData?.teriaryMatchField :
        '',
    dBField3:
      MatchingLogicData && MatchingLogicData?.teriaryMatchDbField ?
        MatchingLogicData?.teriaryMatchDbField :
        '',
  };

  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(getClientCodeDropDownData());
    dispatch(getFormulaRuleDropDownData());
  }, []);
  const schema = Yup.object().shape({
    code: Yup.string()
      .required('code is required')
      .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed'),
    description: Yup.string().required('Description is required'),
  });

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addMatchingLogicStatus === 200 && successMsg) {
      setTimeout(() => {
        setValue(0);
      }, 2500);
    }
  }, [addMatchingLogicStatus, successMsg]);
  const handleSubmit = (values) => {
    if (values) {
      const passValues = {
        clientId: values?.clientCode?.clientNumber ? values?.clientCode?.clientNumber : '',
        description: values?.description ? values?.description : '',
        id: MatchingLogicData?.id ? MatchingLogicData?.id : 0,
        matchingLogicCode: values?.code ? values?.code : '',
        primaryMatchDbField: values?.dBField1 ? values?.dBField1 : '',
        primaryMatchField: values?.matchField1 ? values?.matchField1 : '',
        recordType: values?.recordType ? values?.recordType?.valueCode : '',
        ruleGroupCode: values?.formulaRule?.code ? values?.formulaRule?.code : '',
        secondaryMatchDbField: values?.dBField2 ? values?.dBField2 : '',
        secondaryMatchField: values?.matchField2 ? values?.matchField2 : '',
        teriaryMatchDbField: values?.dBField3 ? values?.dBField3 : '',
        teriaryMatchField: values?.matchField3 ? values?.matchField3 : '',
        exactValue: values?.exactMatch ? 'Y' : 'N',
      };
      dispatch(postMatchingLogicData(passValues));
    }
  };

  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading || successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setValue(0);
          }}

        >
          <ArrowBack className="mr-2" />
                    Search Matching Logic
        </Button>
      </div>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;
            return (
              <div className={`mb-0`}>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <Grid container spacing={2}>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Code"
                          label="Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="code"
                          value={values?.code?.toUpperCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.code && errors.code}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Description`}
                          label="Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          required
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.description && errors.description}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="recordType"
                          id="recordType"
                          size="small"
                          value={values.recordType}
                          options={getOptions(RECORD_TYPE, dropDownData)}
                          getOptionDisabled={(option) => option.valueCode === null}
                          getOptionLabel={(option) => {
                            return option && option.valueCode && option.value ?
                              option.valueCode + ' - ' + option.value :
                              option.value === null ?
                                option.valueCode :
                                option.value ?
                                  option.value :
                                  '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('recordType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.recordType && errors.recordType}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Record Type"
                                placeholder="Select Record Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="clientCode"
                          id="clientCode"
                          size="small"
                          value={values.clientCode}
                          disabled={values.formulaRule}
                          options={clientCodeDropdownData}
                          getOptionDisabled={(option) => option?.clientNumber === ''}
                          getOptionLabel={(option) => {
                            return option && option?.clientName ?
                              option?.clientNumber === null ?
                                option?.clientName :
                                option?.clientNumber + ' - ' + option?.clientName :
                              '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('clientCode', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.clientCode && errors.clientCode}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Client Code"
                                placeholder="Select Client Code"
                              />
                            </div>
                          )}
                        />
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="formulaRule"
                          id="formulaRule"
                          size="small"
                          value={values.formulaRule}
                          disabled={values.clientCode}
                          options={formulaRuleData}
                          getOptionDisabled={(option) => option?.code === ''}
                          getOptionLabel={(option) => {
                            return option && option?.description ?
                              option?.code === null ?
                                option?.description :
                                option?.code + ' - ' + option?.description :
                              '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('formulaRule', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                error={touched.formulaRule && errors.formulaRule}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Data Calculation"
                                placeholder="Select Data Calculation"
                              />
                            </div>
                          )}
                        />
                      </Grid>

                      <Grid item xs={4} xl={4} md={4} sm={6} className="form-group global-fields-checkbox">
                        <Tooltip title="Exact Match">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={handleChange}
                                  name="exactMatch"
                                  checked={values.exactMatch}
                                  color="primary"
                                />
                              }
                              label="Exact Match"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Match Field1"
                          label="Match Field1"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="matchField1"
                          value={values?.matchField1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.matchField1}
                          error={Boolean(touched.matchField1 && errors.matchField1)}
                        />
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter DB Field1"
                          label="DB Field1"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="dBField1"
                          value={values?.dBField1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.dBField1}
                          error={Boolean(touched.dBField1 && errors.dBField1)}
                        />
                      </Grid>
                      <Grid item xs={4} xl={4} md={4} sm={6} className="form-group">

                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Match Field2"
                          label="Match Field2"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="matchField2"
                          value={values?.matchField2}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.matchField2}
                          error={Boolean(touched.matchField2 && errors.matchField2)}
                        />
                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter DB Field2"
                          label="DB Field2"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="dBField2"
                          value={values?.dBField2}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.dBField2}
                          error={Boolean(touched.dBField2 && errors.dBField2)}
                        />
                      </Grid>
                      <Grid item xs={4} xl={4} md={4} sm={6} className="form-group">

                      </Grid>
                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter Match Field3"
                          label="Match Field3"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="matchField3"
                          value={values?.matchField3}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.matchField3}
                          error={Boolean(touched.matchField3 && errors.matchField3)}
                        />
                      </Grid>

                      <Grid item xs={3} xl={4} md={6} sm={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder="Enter DB Field3"
                          label="DB Field3"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="dBField3"
                          value={values?.dBField3}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.dBField3}
                          error={Boolean(touched.dBField3 && errors.dBField3)}
                        />
                      </Grid>
                      <Grid item xs={4} xl={4} md={4} sm={6} className="form-group">

                      </Grid>
                    </Grid>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => resetForm(initialValues)}
                    >
                    Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                    Save
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
        {MatchingLogicData?.matchingLogicCode && (
          <div className={`${classes1.root} mt-3`}>
            <Accordion
              className="accordion-styling"
              expanded={expanded === 'panel1'}
              onChange={handleAccordionChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>
                Matching Logic Notes
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <MatchingLogicSystemNotes matchingLogicCode={MatchingLogicData?.matchingLogicCode} />
              </AccordionDetails>
            </Accordion>
          </div>
        )}
        {isLoading && <PageLoader />}

        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </div>
  );
};

export default AddDMRecordGroupForm;
